import L from "leaflet";

import MarkerPopup from "./MarkerPopup";

const MarkerIcon = (
  type,
  color = [],
  isSelected = false,
  cluster,
  isCluster = false,
  selectedInstitution,
  innerIcon = ""
) => {
  //---------------allow to set an active state (change cluster Icon color) to the cluster via isInCluster
  if (isCluster) {
    // let isInCluster = false;
    // const clusterChildMarkers = cluster.getAllChildMarkers();
    // if (selectedInstitution) {
    //   for (const clusterChildMarker of clusterChildMarkers) {
    //     if (clusterChildMarker.options.calc.id === selectedInstitution.id) {
    //       isInCluster = true;
    //       //cluster.spiderfy();
    //     }
    //   }
    // }

    return L.divIcon({
      // Cluster icon
      html: `
      <svg class="cluster-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
              <circle class="colored-circle" cx="20" cy="20" r="18"/>
              <circle  cx="20" cy="20" r="15" fill="#fff"/>
              </svg>
              <div class="cdg-cluster-icon__child-count">${cluster.getChildCount()}</div>
            `,
      iconSize: L.point(40, 40, true),
      className: "custom-marker-cluster",
    });
  } else {
    // One color marker
    const icon1 = L.divIcon({
      className: `my-custom-pin ${isSelected ? "active" : ""}`,
      iconSize: [40, 40], // size of the icon
      iconAnchor: [20, 40],
      labelAnchor: [-6, 0],
      popupAnchor: [0, -40],
      html: `
      <div class="markerIcon">
      <svg class="icon-${type} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
          <path d="M459.4 217.81c0-116.15-94.57-210.21-210.91-209.39-113.5.8-206.39 93.11-207.86 206.61-1 76.88 39.45 144.39 100.41 181.61 40.1 24.48 75.68 55.69 104.09 93.11l4.39 5.78 13.53-16.23c26.86-32.21 58.53-60.23 94.49-81.8 61.02-36.59 101.86-103.37 101.86-179.69z" fill="${color[0]}"/>
      </svg>
      <div class="innerIcon">${innerIcon}</div>
      </div>
      `,
    });
    return icon1;
  }
};

export default MarkerIcon;
